import AboutUsImg from '../../images/Group_743.png';
import './AboutUs.scss';
import CustomButton from '../utils/CustomButton';
import { East } from '@mui/icons-material';

function AboutUs() {
    return (
        <div className="about-us-wrp wrapper" id="about">
            <div className='about-us-title'>About Us</div>
            <div className='about-us-content-wrp'>
                <div>
                    <div className='about-us-content'>
                        jobfi.in have started in 2019 Commencement year 2019 and our core belief is to deliver an excellent experience to our subscribers. It is one of the best platforms to find all types of online jobs that you can do from the comfort of your home. We help to connect freelancers with firms that need skilled candidates. We aim to encourage people to use their skills and free time to earn a handsome amount. If you are a housewife, student, working professional, or teenager, then you have reached the best website to put your skill and talent to use.
                        <br></br>
                        <span className='about-sub-content'>The platform is not just for small jobs, you can even find bigger projects opt for ones with fixed price or hourly payment. You can talk to clients regarding the milestone, schedule, and cost before starting a project.</span>
                    </div>
                    <CustomButton name='Read More' icon={<East/>}/>
                </div>
                <img className='about-us-img' src={AboutUsImg} alt='about-us' />
            </div>
        </div>
    );
}

export default AboutUs;